import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SignalButton, ToastService } from '@vallift/ngl';

@Component({
  selector: 'app-toast-test-confirm-overlay',
  standalone: true,
  imports: [SignalButton],
  templateUrl: './toast-test-confirm-overlay.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastTestConfirmOverlayComponent {
  private readonly dialogRef = inject(DialogRef<boolean>);
  private readonly toast = inject(ToastService);

  onNo(): void {
    this.dialogRef.close(false);
  }

  onYes(): void {
    // Keep popup open to verify toast stacks above dialogs.
    this.toast.success('Toast shown while confirm popup is still open.', {
      title: 'Yes clicked',
    });
  }
}
